import React, { Component } from "react"
// import PropTypes from "prop-types"
import { Popover } from "antd"
import styled from "styled-components"
// import bandUrl from "../assets/image/band.jpg"
import userUrl from "../assets/image/os-icon-user.png"
import Popup from '@/components/Header/popup'
import CommonAPI from '@/API/common'
import { setOperator, setRoleId } from '@/store/actionCreators'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const Contain = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`
const Brand = styled.div`
  font-size:20px;
  font-weight:bold; 
`

const UserName = styled.span`
  margin-right:10px;
`

const User = styled.img`
  width: 16px;
  height: 16px;
  margin-right:8px;
`

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      operator: '',
      userInfoUrl: ''
    };
  }
  componentDidMount() {
    this.changeTitle()
    this.getUserInfo()
  }
  changeTitle = () => {
    document.title = this.props.t('R-Guard');
  }
  getUserInfo = () => {
    CommonAPI.getUserInfo().then((res) => {
      this.setState({ userName: res.userName, operator: res.operator, userInfoUrl: res.userInfoUrl })
      this.props.setRoleId(res.roleId)
      this.props.setOperator(res.operator)
    })
  }

  render() {
    const { userName, operator, userInfoUrl } = this.state
    const { t } = this.props
    return (
      <Contain className={this.props.className}>
        <Brand>{t('R-Guard')}</Brand>
        <Popover content={<Popup operator={operator} userInfoUrl={userInfoUrl}></Popup>} placement="bottomLeft">
          <User src={userUrl} />
          <UserName>{userName}</UserName>
        </Popover>
      </Contain>
    )
  }
}

const mapDispatchToProps = { setOperator, setRoleId }

export default connect(null, mapDispatchToProps)(withTranslation()(Header))
